<div *ngIf="loader" class="spinner-wrapper">
    <mis-loader [mobileView]="false"></mis-loader>
</div>
<div *ngIf="!loader" class="d-flex main">
    <div class="side-bar-btn-box" [ngClass]="{'closed': !showSideBar}">
        <app-side-bar-tr *ngIf="showSideBar" [isCabView]="true" [adhoc_text]="adhoc_text" ></app-side-bar-tr>
        <div style="background-image: url({{replayImgSrc}}assets/icons/left-carrot.svg)" class="close_btn" id="left_pane_close_btn" (click)="toggleSideBar()" [ngClass]="{'closed': !showSideBar}"></div>
    </div>
    <div class="map-player-container" *ngIf="!loader">
        <app-map-view-cab [driverData]="driverData" (reStart)="getMilestones()"></app-map-view-cab>
        <app-trip-player [driverData]="driverData"></app-trip-player>
    </div>
</div>